import cn from 'classnames';
import PropTypes from 'prop-types';

function PullQuote({
  ariaLabel = undefined,
  children,
  className = undefined,
  outlined = false,
  role = undefined,
  ...rest
}) {
  return (
    <div
      aria-label={ariaLabel}
      className={cn(
        'pull-quote-wrapper text-center',
        {
          outlined,
        },
        className
      )}
      role={role}
      {...rest}
    >
      <div className="quote-icon">
        <svg width="48" height="38" viewBox="0 0 48 38" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 37.9492V27.0361C0 23.8623 0.610352 20.5908 1.83105 17.2217C3.05176 13.8525 4.66309 10.6787 6.66504 7.7002C8.66699 4.67285 10.8643 2.10938 13.2568 0.00976562L23.0713 5.72266C21.3135 8.65234 19.7998 11.8018 18.5303 15.1709C17.2607 18.54 16.626 22.4951 16.626 27.0361V37.9492H0ZM24.9023 37.9492V27.0361C24.9023 23.8623 25.5127 20.5908 26.7334 17.2217C27.9541 13.8525 29.5654 10.6787 31.5674 7.7002C33.5693 4.67285 35.7666 2.10938 38.1592 0.00976562L47.9736 5.72266C46.2158 8.65234 44.7021 11.8018 43.4326 15.1709C42.1631 18.54 41.5283 22.4951 41.5283 27.0361V37.9492H24.9023Z" fill="#007FAD"/>
        </svg>
      </div>
      {children}
    </div>
  );
}

export default PullQuote;

PullQuote.propTypes = {
  ariaLabel: PropTypes.string,
  classes: PropTypes.string,
  outlined: PropTypes.bool,
  role: PropTypes.string,
};